
import { useState } from "react";
import axios from "axios";

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v';

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  return JSON.parse(data);
}

export default function OrderExportButton() {

    const apiToken = getLocalData().api_token;
    const API_URL = process.env.REACT_APP_API_URL;
    const ORDERS = `${API_URL}/user/orders/export`;

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const filters = [
        { label: "Last 30 Days", value: "this_month" },
        { label: "This Year", value: "this_year" },
        { label: "Year 2025", value: "2025" },
        { label: "Year 2024", value: "2024" },
        { label: "All Orders", value: "all" },
    ];

    const handleExport = async (filter) => {

            setLoading(true);
            setOpen(false);

            const config = {
                headers: { Authorization: `Bearer ${apiToken}` },
                params: {
                    filter: filter,
                },
                responseType: "blob",
            };

            await axios.get(ORDERS, config)
            .then((response) => {
               const url = window.URL.createObjectURL(
                    new Blob([response.data])
                );

                const link = document.createElement("a");
                link.href = url;
                link.download = `orders_${filter}.xlsx`;
                document.body.appendChild(link);
                link.click();
                link.remove();

                window.URL.revokeObjectURL(url);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    };

    return (
        <div
            className="dropdown ms-2"
            style={{ position: "relative", display: "inline-block" }}
        >
            <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={() => setOpen(!open)}
                disabled={loading}
            >
                {loading ? "Downloading..." : "Export CSV"}
                {!loading && (
                    <span className="ms-2">▼</span>
                )}
            </button>

            {open && (
                <div
                    className="dropdown-menu show"
                    style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        minWidth: "180px",
                        zIndex: 1000,
                    }}
                >
                    {filters.map((item) => (
                        <button
                            key={item.value}
                            type="button"
                            className="dropdown-item"
                            onClick={() => handleExport(item.value)}
                            disabled={loading}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
